<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';

    import ButtonMain from '../ButtonMain.svelte';
    import ButtonRemove from '../ButtonRemove.svelte';
    import { type DashboardComponentType, WidgetManager } from './WidgetManager';
    import WidgetSettingsTemplateInner from './WidgetSettingsTemplateInner.svelte';

    export let isOpen: boolean = false;
    export let onRemove: () => void;
    export let onSave: (settings: any) => void;
    // export let componentSettings: any;
    export let settings: any = {};
    export let dashboardItem: DashboardComponentType;
    export let widgetManager: WidgetManager | null = null;

    let currentSettings: any = JSON.parse(JSON.stringify(settings));
    let allowSave: boolean = true;
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="dialog-container">
            <div class="dialog-header">{$_('Settings')}</div>

            <div class="js-dialog-container">
                <!--{JSON.stringify(settings)}-->
                <WidgetSettingsTemplateInner
                    bind:settings={currentSettings}
                    {dashboardItem}
                    bind:allowSave
                />
                <!--                <svelte:component-->
                <!--                    this={componentSettings}-->
                <!--                    bind:settings={currentSettings}-->
                <!--                    bind:allowSave-->
                <!--                />-->
            </div>

            <div class="actions">
                <ButtonRemove
                    text={$_('Remove widget')}
                    showIcon={false}
                    on:click={() => {
                        onRemove();
                        // widgetManager = widgetManager;
                        closeModal();
                    }}
                />
                <ButtonMain
                    text={$_('Save')}
                    disabled={!allowSave}
                    on:click={() => {
                        onSave(JSON.parse(JSON.stringify(currentSettings)));
                        // widgetManager = widgetManager;
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .dialog-container {
        pointer-events: auto;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        min-width: 590px;
        max-width: 590px;
        min-height: 300px;
        row-gap: 10px;
        background-color: #dbdbd6;
        padding: 20px;
        border-radius: 6px;
        box-shadow: -1px 11px 31px -10px rgba(0, 0, 0, 0.75);
    }

    .dialog-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ccc;
        font-weight: 600;
        font-size: 18px;
        height: 40px;
        padding: 10px 10px 20px 10px;
    }

    .js-dialog-container {
        flex: 10 1 auto;
        padding: 10px;
    }
    .actions {
        border-top: 1px solid #ccc;
        padding: 20px 10px 10px 10px;
        column-gap: 20px;
        display: flex;
        justify-content: space-between;
    }
</style>
